import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Observable } from 'rxjs';
import { SectionConfigModel } from '../../models/section-configuration.model';
import { SectionConfigurationService } from '../../services/section-configuration.service';

@Component({
    selector: 'section-list',
    templateUrl: 'section-list.component.html',
    styleUrls: ['section-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SectionListComponent {
  readonly sectionConfigs$: Observable<SectionConfigModel[]>;

  constructor(configService: SectionConfigurationService) {
    this.sectionConfigs$ = configService.getSectionConfiguration();
  }
}
